import PropTypes from 'prop-types';
import React from 'react';

import { formatCurrency } from '../utils/utility';

export default class Options extends React.Component {
	render() {
		const { deviceType, options, showPricing, locale } = this.props;
		if (options.length === 0) {
			return null;
		}
		const indentStyles = deviceType === 'DESKTOP' ? 'ml-6' : '';
		return (
			<div className="mb-3">
				<strong className="mb-4 d-flex">Included Options</strong>
				<ul className="list-unstyled list-spaced">
					{options.map(option => {
						const { name, price } = option;
						const displayPrice =
							price !== 0 ? (
								<strong className="option-price ml-auto pl-5">
									{formatCurrency(price, locale)}
								</strong>
							) : null;
						return [
							<li key={name} className={indentStyles}>
								<div className="d-flex">
									<span className="option-title text-muted">
										{name}
									</span>
									{showPricing ? displayPrice : null}
								</div>
							</li>
						];
					})}
				</ul>
			</div>
		);
	}
}

Options.defaultProps = {
	locale: 'en_US',
	options: []
};

Options.propTypes = {
	deviceType: PropTypes.string.isRequired,
	locale: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			price: PropTypes.number.isRequired
		})
	),
	showPricing: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Options.jsx